import React, { type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { SortableList } from 'mailup-web-components'

import ColumnItem from 'Pages/RecipientsList/components/modals/columns/ColumnItem'

import { modalConfigColumnsReorderCallback } from 'Pages/RecipientsList/recoil/callbacks/modals'
import { modalColumnsState } from 'Pages/RecipientsList/recoil/state/modals'

const ColumnsList: FC = () => {
  const { items: cols } = useRecoilValue(modalColumnsState)

  const columnsReorder = useRecoilCallback(
    modalConfigColumnsReorderCallback,
    [],
  )

  const items = cols.map((c, i) => ({
    content: <ColumnItem index={i} canDelete={cols.length > 1} />,
    canMove: true,
  }))

  const handleChange = ({
    type,
    payload: { from, to },
  }: {
    type: 'reorder'
    payload: {
      from: number
      to: number
    }
  }): void => {
    void columnsReorder(from, to)
  }

  return (
    <SortableList items={items} onChange={handleChange} emptyState={null} />
  )
}

export default ColumnsList
